import React from 'react';

import Container from '@src/components/Container';
import JourneyCard from '@src/components/JourneyCard';
import RefreshControl from '@src/components/RefreshControl';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import WhereButton from '@src/components/WhereButton';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';
import useTopJourneys from '@src/hooks/useTopJourneys';
import { Journey } from '@src/types';

import { List } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = () => {
  const handleScroll = useAnimatedHeader();

  const [activeRegion, setActiveRegion] = React.useState<string>();
  const { data, refreshing, handleRefresh, handleEndReached } = useTopJourneys(
    activeRegion
  );

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          ListHeaderComponent={<WhereButton onRegion={setActiveRegion} />}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
          }
          onScroll={handleScroll}
          onEndReached={handleEndReached}
          data={data}
          renderItem={({ item }: { item: Journey }) => (
            <JourneyCard item={item} />
          )}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'TopJourneys';

export default Screen;
